import { motion, type Variants } from "motion/react";
import type { FC, PropsWithChildren } from "react";

export const HandWaveAnimation: FC<PropsWithChildren> = (props) => {
	return (
		<motion.span
			style={{
				cursor: "default",
				marginLeft: "12px",
				fontSize: "32px",
				display: "inline-block",
				transformOrigin: "70% 70%",
			}}
			variants={waveVariants}
			initial="initial"
			animate="wave"
			whileHover="hover"
		>
			{props.children}
		</motion.span>
	);
};

const waveVariants: Variants = {
	initial: { rotate: 0, x: 0, y: 0 },
	wave: {
		rotate: [0, 14, -8, 14, -4, 10, 0],
		x: [0, 2, -2, 1, -1, 0, 0],
		y: [0, -2, 2, -1, 1, 0, 0],
		transition: {
			duration: 1.2,
			repeat: 0,
		},
	},
	hover: {
		rotate: [0, 14, -8, 14, -4, 10, 0],
		x: [0, 2, -2, 1, -1, 0, 0],
		y: [0, -2, 2, -1, 1, 0, 0],
		transition: {
			duration: 1.2,
			repeat: 0,
		},
	},
};
